import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AppConfig } from '@config/app.config';
import { AuthenticationService } from '@core/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  constructor(
    public appConfig: AppConfig,
    public authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    const path = activatedRoute.routeConfig.path;

    if (this.authenticationService.validateLogin()) {
      if (path === 'login') {
        this.router.navigate(['']);
      }

      return true;
    }

    if (path === 'login') {
      return true;
    }

    this.router.navigate(['/login']);

    return false;
  }
}
